import { Center, Heading, Link, Text } from '@chakra-ui/react';
import RobotIcon from 'src/assets/icons/RobotIcon';
import { Link as RouterLink } from 'react-router-dom';
import LoginForm from './LoginForm';
import LoginLayout from './LoginLayout';

export default function Login() {
  return (
    <LoginLayout title="Login">
      <Center mb="16px">
        <RobotIcon />
      </Center>
      <Heading size="h3" as="h1" textAlign="center">
        Welcome Back 😊
      </Heading>
      <Text size="p2" textAlign="center" mt="8px" variant="lighter">
        Not with Alitu yet?{' '}
        <Link as={RouterLink} to="/signup">
          Try us out, today.
        </Link>
      </Text>
      <LoginForm mt={['24px', '30px']} mb="27px" />
      <Text size="p3" variant="lighter" textAlign="center">
        Not with Alitu yet?{' '}
        <Link as={RouterLink} to="/signup">
          Register
        </Link>
      </Text>
    </LoginLayout>
  );
}
